import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { enqueueSnackbar } from 'notistack';

import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { MutationStateFns } from '@/api/utils/mutation';
import { useAuth } from '@/context/AuthProvider';

export type ApiResponse_StoreManagerResponseTo_Email = {
  session_id: string;
};

export type ApiRequest_StoreManagerResponseTo_Email = {
  sessionId: string;
  message: string;
  propertyId: string;
  title?: string;
};

const METHOD = 'POST';
const ENDPOINT = 'email/manager-response';

export const useStoreManagerResponseToEmail = (
  stateFns?: MutationStateFns<ApiResponse_StoreManagerResponseTo_Email>
) => {
  const { session } = useAuth();

  return useMutation({
    mutationFn: async (data: ApiRequest_StoreManagerResponseTo_Email) =>
      handleApiCall<
        ApiResponse_StoreManagerResponseTo_Email,
        ApiRequest_StoreManagerResponseTo_Email
      >(session, METHOD, getResolvedEndpoint(ENDPOINT, {}), data),
    onSuccess: data => {
      enqueueSnackbar('Manager response stored successfully', { variant: 'success' });

      stateFns?.onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      enqueueSnackbar('Failed to store manager response', { variant: 'error' });

      // eslint-disable-next-line no-console
      console.error(err);
      stateFns?.onError?.(err);
    },
  });
};
